const DEFAULT_API_URL = 'http://localhost:5000'

export const API_CONFIG = {
  baseURL: window.env?.VITE_API_URL || DEFAULT_API_URL
} as const
